import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function getAcCertificatesReducer (state: RootState): AcCertificatesState {
  return state.acCertificatesReducer
}